import {HttpClient} from '@angular/common/http';
import {PublisherInvoice} from '../domain/publisher-invoice.model';
import {environment} from '../../../environments/environment';
import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import {HttpUtils} from '../utils/http-utils';
import {InvoicesResponse} from '../domain/invoices-response.model';

@Injectable()
export class PublisherInvoicesService {

  constructor(private http: HttpClient) {
  }

  netPaymentTermsList(): Observable<number[]> {
    return this.http.get<number[]>(`${environment.serviceUrl}/ad-stats/publisher-invoices/net-payment-terms`);
  }

  listInvoices(pubId: string, page: number, size: number, sortField: string, sortDirection: string, paid?: boolean): Observable<InvoicesResponse> {
    return this.http.get<InvoicesResponse>(`${environment.serviceUrl}/ad-stats/publisher-invoices/${pubId}`, {
      params: HttpUtils.getHttpParams({
        page: page,
        size: size,
        sortField: sortField ? [sortField, 'createdOn'] : null,
        sortDirection: sortDirection,
        paid: paid,
      })
    });
  }

  listAllInvoices(pubId: string, page: number, size: number, sortField: string, sortDirection: string, paid?: boolean, months = null, year = null): Observable<InvoicesResponse> {
    return this.http.get<InvoicesResponse>(`${environment.serviceUrl}/ad-stats/publisher-invoices/all`, {
      params: HttpUtils.getHttpParams({
        publisherId: pubId,
        page: page,
        size: size,
        sortField: sortField ? [sortField, 'createdOn'] : null,
        sortDirection: sortDirection,
        paid: paid,
        month: months,
        year: year
      })
    });
  }

  createInvoice(pubId: string, dateReceived: string, file: File, amount = null, month = null, year = null): Observable<PublisherInvoice> {
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    formData.append('dateReceived', dateReceived);
    formData.append('month', month);
    formData.append('year', year);
    formData.append('amount', amount);
    return this.http.post<PublisherInvoice>(`${environment.serviceUrl}/ad-stats/publisher-invoices/${pubId}`, formData);
  }

  updateInvoice(invoice: PublisherInvoice): Observable<PublisherInvoice> {
    return this.http.put<PublisherInvoice>(`${environment.serviceUrl}/ad-stats/publisher-invoices/${invoice.id}`, invoice);
  }

  updateInvoicePaidMultiple(invoices: PublisherInvoice[], datePaid): Observable<PublisherInvoice[]> {
    return this.http.put<PublisherInvoice[]>(`${environment.serviceUrl}/ad-stats/publisher-invoices/paid`, HttpUtils.getHttpParams({
      invoiceId: invoices.map(i => i.id),
      datePaid: datePaid
    }));
  }

  deleteInvoice(invoice: PublisherInvoice) {
    return this.http.delete(`${environment.serviceUrl}/ad-stats/publisher-invoices/${invoice.id}`);
  }

  invoiceExport(pubId: string, paid: boolean) {
    return this.http.get(`${environment.serviceUrl}/ad-stats/publisher-invoices/export/${pubId}`, {
      responseType: 'text',
      params: HttpUtils.getHttpParams({
        paid: paid
      })
    });
  }

  invoiceExportAll(pubId?: string, paid?: boolean) {
    return this.http.get(`${environment.serviceUrl}/ad-stats/publisher-invoices/export/all`, {
      responseType: 'text',
      params: HttpUtils.getHttpParams({
        publisher_id: pubId,
        paid: paid
      })
    });
  }

  downloadInvoices(invoices: PublisherInvoice[]) {
    return this.http.get(`${environment.serviceUrl}/ad-stats/publisher-invoices/invoices`, {
      responseType: 'blob',
      params: HttpUtils.getHttpParams({
        invoiceId: invoices.map(i=>i.id)
      })
    });
  }
}
